import globalIP from '@/GlobelIP';
import React from 'react';
import { Col, Row } from 'rsuite';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
function ProductGridView({
  productData,
  allQyeryData,
  expendFilter,
  dataGrid,
  dataGrid2,
  handleHover,
  handleMouseLeave,
  isHoveredID,
  isHovered,
  handleOpen,
  handleCheckChange,
  selectedItems,
  isShowButton
}) {
 
  const renderProduct = (item, exist) => {
    const searchParams = new URLSearchParams(location.search);
    const con = searchParams.get('conid');
    const condition = Number(con);
    return (
      <div className="product-box">
        <div
          className={'product-img'}
          style={{
            overflow: 'hidden',
            height:
              (dataGrid2 == 4 && !expendFilter) || (dataGrid2 == 4 && expendFilter)
                ? '200px'
                : dataGrid == 6 && expendFilter
                ? '240px'
                : null
          }}
          onMouseEnter={() => handleHover(item.id)}
          onMouseLeave={() => handleMouseLeave()}
        >
          {!item?.attributes.MultipleImage?.data || isHoveredID != item.id ? (
            <img
              src={`${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`}
              alt=""
              className="imgp111111"
              loading="lazy"
              style={{
                height:
                  (dataGrid2 == 4 && !expendFilter) || (dataGrid2 == 4 && expendFilter)
                    ? '160px'
                    : dataGrid == 6 && expendFilter
                    ? '175px'
                    : null
              }}
            />
          ) : null}

          {isHovered && isHoveredID == item.id && item?.attributes.MultipleImage?.data ? (
            <Swiper
              navigation={true}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false
              }}
              loop
              modules={[EffectFade, Navigation]}
              className="mySwiper-2"
            >
              {item?.attributes.MultipleImage?.data.map(image => {
                return (
                  <SwiperSlide
                    key={image.id}
                    style={{
                      width: '100%',
                      height:
                        (dataGrid2 == 4 && !expendFilter) || (dataGrid2 == 4 && expendFilter)
                          ? '200px'
                          : dataGrid == 6 && expendFilter
                          ? '240px'
                          : null
                    }}
                  >
                    <img
                      src={`${globalIP}${image.attributes.url}`}
                      className="imgp111111"
                      loading="lazy"
                      style={{
                        height:
                          (dataGrid2 == 4 && !expendFilter) || (dataGrid2 == 4 && expendFilter)
                            ? '160px'
                            : dataGrid == 6 && expendFilter
                            ? '175px'
                            : null
                      }}
                    />
                  </SwiperSlide>
                );
              })}
              <SwiperSlide
                style={{
                  width: '100%',
                  height:
                    (dataGrid2 == 4 && !expendFilter) || (dataGrid2 == 4 && expendFilter)
                      ? '200px'
                      : dataGrid == 6 && expendFilter
                      ? '240px'
                      : null
                }}
              >
                <img
                  src={`${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`}
                  alt=""
                  className="imgp111111"
                  style={{
                    height:
                      (dataGrid2 == 4 && !expendFilter) || (dataGrid2 == 4 && expendFilter)
                        ? '166px'
                        : dataGrid == 6 && expendFilter
                        ? '175px'
                        : null
                  }}
                  loading="lazy"
                />
              </SwiperSlide>
            </Swiper>
          ) : null}
          {isHoveredID == item.id && (
            <div className="product-view roboto-light" onClick={() => handleOpen(item.id)}>
              <span className="material-symbols-outlined">visibility</span>View Details
            </div>
          )}
          <div className="ribbon1">
            <span className="ribbon__content1">Exclusive</span>
          </div>
          {condition == 1 ? null : (
            <>
              <div className="selected-button" style={{ zIndex: 1 }}>
                <span className="heart-circle">
                  {!exist ? (
                    <div
                      onClick={() =>
                        handleCheckChange(
                          item.id,
                          !selectedItems.includes(item.id),
                          item.attributes.ProductCode
                        )
                      }
                      style={{ display: 'flex' }}
                    >
                      {selectedItems.includes(item.id) ? (
                        <svg className="heart" viewBox="0 0 32 29.6">
                          <path
                            d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2
c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z"
                          />
                        </svg>
                      ) : (
                        <span className="material-symbols-outlined">favorite</span>
                      )}
                    </div>
                  ) : (
                    <svg className="heart-1" viewBox="0 0 32 29.6">
                      <path
                        d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2
c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z"
                      />
                    </svg>
                  )}
                </span>
              </div>
            </>
          )}
        </div>
        <div className="product-details">
          <h6
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            Product : <span className="roboto-regular">{item?.attributes?.ProductName}</span>
          </h6>
          <h6
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            Alias Code : <span className="roboto-regular"> {item?.attributes?.ProductId}</span>
          </h6>
        </div>
      </div>
    );
  };
  return (
    <>
      <Row className="product-hide-mobile">
        {productData.map(item => {
          const exist = allQyeryData?.some(ite => ite.productid == item?.id);
          return (
            <Col
              lg={expendFilter && isShowButton.filter ? dataGrid : dataGrid2}
              key={item.id}
              md={24}
            >
              {renderProduct(item, exist)}
            </Col>
          );
        })}
      </Row>
      <Row className="product-show-mobile" style={{ marginBottom: '50px' }}>
        {productData.map(item => {
          const exist = allQyeryData?.some(ite => ite.productid == item?.id);
          return (
            <Col xs={24} key={item.id}>
              {renderProduct(item, exist)}
            </Col>
          );
        })}
      </Row>
    </>
  );
}
export default React.memo(ProductGridView);
